// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .wrap_about{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    /* background-color: rgb(255, 255, 255); */
    justify-content:center;
    align-content:space-around;
    align-items: center;
    margin: 0 auto;
    padding: 0 10px;
    overflow: hidden;
    
  }
  
  .wrap_chica{
    height: 681px;
    width: 951px;
       
  }
  
  .bolsa{
   height: auto;
   width: 223px;
    position: absolute;
    left: 0px;
    margin-top: 10px;
  
  }
  
  .chica  {
    height: 667px;
    width: auto;
    margin-left: 1px;
 }


  
  .text_chica h1{
    font-family: 'Bebas Neue', cursive;
    font-size: 115px;
    line-height: 105px;
    margin-bottom: 11px;
    
  }

  .text_chica {
    padding: 0;
    width: 659px;}
  
  .textoChicaWrap{
  width: 577px;
  }


  .text_chica p{
    font-family: 'Rubik', sans-serif;
    font-size: 19px;
    line-height: 29px;
  
  }
  
  .color1{color: rgb(255, 0, 140);}
  
 
  
  

@media screen and (max-width: 1699px) {

  .wrap_about{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  /* background-color: rgb(161, 22, 22); */
  justify-content:center;
  align-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0 10px;
  overflow: hidden;
  
  column-gap: 1px;
}

.wrap_chica{
  height: auto;
width: 612px;

}

.bolsa{
 height: auto;
 width: 191px;
  position: absolute;
  left: 0px;
  margin-top: 10px;

}

.chica  {
  height: 433px;
  width: auto;

 
}

.text_chica h1{
  font-family: 'Bebas Neue', cursive;
  font-size: 75px;
  line-height: 75px;
  margin-bottom: 11px;
  
}
.text_chica p{
  font-family: 'Rubik', sans-serif;
  font-size: 15px;
  line-height: 25px;

}
.text_chica {padding: 0;
  width: 471px;}

.textoChicaWrap{
width: 437px;
}
.color1{color: rgb(255, 0, 140);}}

@media screen and (max-width: 1159px) {
  .text_chica {width: 465px;}
}



@media screen and (max-width: 655px) {
 
  .wrap_about{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction:column-reverse;
    /* background-color: rgb(161, 22, 22); */
    justify-content:center;
    align-content: center;
    align-items: center;
    margin: 0 auto;
    padding: 0 10px;
    overflow: hidden;    
    column-gap: 1px;
  }

.text_chica {padding: 0;
  width: 415px;}

.textoChicaWrap{
width: 391px;
}

}

@media screen and (max-width: 397px) {
.bolsa{display: none;}
  .text_chica h1{
   
    font-size:35px;
    line-height: 35px;
    margin-bottom: 7px;
    
  }
  .text_chica p{
    
    font-size: 11px;
    line-height: 15px;
    margin-bottom: 29px;
  
  }

  .text_chica {padding: 0;
    width: 319px;}
  
  .textoChicaWrap{
  width:261px;
  }
  

}`, "",{"version":3,"sources":["webpack://./src/components/about/about.css"],"names":[],"mappings":";EACE;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,0CAA0C;IAC1C,sBAAsB;IACtB,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;;EAElB;;EAEA;IACE,aAAa;IACb,YAAY;;EAEd;;EAEA;GACC,YAAY;GACZ,YAAY;IACX,kBAAkB;IAClB,SAAS;IACT,gBAAgB;;EAElB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,gBAAgB;CACnB;;;;EAIC;IACE,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;;EAErB;;EAEA;IACE,UAAU;IACV,YAAY,CAAC;;EAEf;EACA,YAAY;EACZ;;;EAGA;IACE,gCAAgC;IAChC,eAAe;IACf,iBAAiB;;EAEnB;;EAEA,QAAQ,uBAAuB,CAAC;;;;;;AAMlC;;EAEE;EACA,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd,YAAY;;AAEZ;;AAEA;CACC,YAAY;CACZ,YAAY;EACX,kBAAkB;EAClB,SAAS;EACT,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,WAAW;;;AAGb;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;;AAErB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;;AAEnB;AACA,aAAa,UAAU;EACrB,YAAY,CAAC;;AAEf;AACA,YAAY;AACZ;AACA,QAAQ,uBAAuB,CAAC,CAAC;;AAEjC;EACE,aAAa,YAAY,CAAC;AAC5B;;;;AAIA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,wCAAwC;IACxC,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;AAEF,aAAa,UAAU;EACrB,YAAY,CAAC;;AAEf;AACA,YAAY;AACZ;;AAEA;;AAEA;AACA,OAAO,aAAa,CAAC;EACnB;;IAEE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;;EAEpB;EACA;;IAEE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;;EAErB;;EAEA,aAAa,UAAU;IACrB,YAAY,CAAC;;EAEf;EACA,WAAW;EACX;;;AAGF","sourcesContent":["\n  .wrap_about{\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    /* background-color: rgb(255, 255, 255); */\n    justify-content:center;\n    align-content:space-around;\n    align-items: center;\n    margin: 0 auto;\n    padding: 0 10px;\n    overflow: hidden;\n    \n  }\n  \n  .wrap_chica{\n    height: 681px;\n    width: 951px;\n       \n  }\n  \n  .bolsa{\n   height: auto;\n   width: 223px;\n    position: absolute;\n    left: 0px;\n    margin-top: 10px;\n  \n  }\n  \n  .chica  {\n    height: 667px;\n    width: auto;\n    margin-left: 1px;\n }\n\n\n  \n  .text_chica h1{\n    font-family: 'Bebas Neue', cursive;\n    font-size: 115px;\n    line-height: 105px;\n    margin-bottom: 11px;\n    \n  }\n\n  .text_chica {\n    padding: 0;\n    width: 659px;}\n  \n  .textoChicaWrap{\n  width: 577px;\n  }\n\n\n  .text_chica p{\n    font-family: 'Rubik', sans-serif;\n    font-size: 19px;\n    line-height: 29px;\n  \n  }\n  \n  .color1{color: rgb(255, 0, 140);}\n  \n \n  \n  \n\n@media screen and (max-width: 1699px) {\n\n  .wrap_about{\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  /* background-color: rgb(161, 22, 22); */\n  justify-content:center;\n  align-content: center;\n  align-items: center;\n  margin: 0 auto;\n  padding: 0 10px;\n  overflow: hidden;\n  \n  column-gap: 1px;\n}\n\n.wrap_chica{\n  height: auto;\nwidth: 612px;\n\n}\n\n.bolsa{\n height: auto;\n width: 191px;\n  position: absolute;\n  left: 0px;\n  margin-top: 10px;\n\n}\n\n.chica  {\n  height: 433px;\n  width: auto;\n\n \n}\n\n.text_chica h1{\n  font-family: 'Bebas Neue', cursive;\n  font-size: 75px;\n  line-height: 75px;\n  margin-bottom: 11px;\n  \n}\n.text_chica p{\n  font-family: 'Rubik', sans-serif;\n  font-size: 15px;\n  line-height: 25px;\n\n}\n.text_chica {padding: 0;\n  width: 471px;}\n\n.textoChicaWrap{\nwidth: 437px;\n}\n.color1{color: rgb(255, 0, 140);}}\n\n@media screen and (max-width: 1159px) {\n  .text_chica {width: 465px;}\n}\n\n\n\n@media screen and (max-width: 655px) {\n \n  .wrap_about{\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction:column-reverse;\n    /* background-color: rgb(161, 22, 22); */\n    justify-content:center;\n    align-content: center;\n    align-items: center;\n    margin: 0 auto;\n    padding: 0 10px;\n    overflow: hidden;    \n    column-gap: 1px;\n  }\n\n.text_chica {padding: 0;\n  width: 415px;}\n\n.textoChicaWrap{\nwidth: 391px;\n}\n\n}\n\n@media screen and (max-width: 397px) {\n.bolsa{display: none;}\n  .text_chica h1{\n   \n    font-size:35px;\n    line-height: 35px;\n    margin-bottom: 7px;\n    \n  }\n  .text_chica p{\n    \n    font-size: 11px;\n    line-height: 15px;\n    margin-bottom: 29px;\n  \n  }\n\n  .text_chica {padding: 0;\n    width: 319px;}\n  \n  .textoChicaWrap{\n  width:261px;\n  }\n  \n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
